
<template>
  <!-- 季度选择时间控件 -->
  <div class="year-picker">
    <el-date-picker
      v-model="beginTime"
      type="year"
      align="right"
      value-format="yyyy"
      :picker-options="isInterval? pickerOptionsIntervalYearEnd:pickerOptionsYearEnd"
      :clearable="false"
      style="width: 120px;"
      @change="changeTime"
      prefix-icon="icon icon-calendar"
      :placeholder="$t('components_yearRangePicker.kai_shi_nian')">
    </el-date-picker>
    -
    <el-date-picker
      v-model="endTime"
      type="year"
      align="right"
      value-format="yyyy"
      :picker-options="isInterval? pickerOptionsIntervalThreeYears : pickerOptionsYear"
      :clearable="false"
      style="width: 120px;"
      @change="changeTime"
      prefix-icon="icon icon-calendar"
      :placeholder="$t('components_yearRangePicker.jie_shu_nian')">
    </el-date-picker>
  </div>
</template>
<script>
/**
 * @file:  View 组件 季节选择控件
 * @description: UI组件  可选择季节
 * @api: valueArr : 季度value defalut[2023,2025] 默认值待设置
 * 代码中注释部分是组件原默认时间配置，我这里做了更改，但是原设置可以参考
 */
export default {
  name: 'YearRangpicker',
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    isInterval: {
      type: Boolean,
      default() {
        return false;
      }
    },
  },
  data() {
    return {
      beginTime: this.value[0],
      endTime: this.value[1],
      pickerOptionsYear: {
        disabledDate: time => time.getFullYear() < 2016 // 注意是 || 不是 && 哦
      },
      pickerOptionsYearEnd: {
        disabledDate: time => time.getFullYear() > this.endTime - 1 || time.getFullYear() < 2016 // 注意是 || 不是 && 哦
      },
      pickerOptionsIntervalYearEnd: {
        // disabledDate: time => time.getFullYear() > this.endTime - 1 // 注意是 || 不是 && 哦
        disabledDate: time => {
          const selectedYear = time.getFullYear();
          // 同时满足两个条件：不能超过结束年-1，且年份跨度不超过3年

          return selectedYear > this.endTime - 1
           || selectedYear < this.endTime - 2 || selectedYear < 2016;
        }
      },
      pickerOptionsIntervalThreeYears: {
        disabledDate: time => {
          const currentYear = new Date().getFullYear();
          // 计算可选的年份范围
          const startYear = Math.max(2016, +this.beginTime - 2); // beginTime 前两年，但不小于2016 // beginTime 前两年
          const endYear = +this.beginTime + 2; // beginTime 后两年
          // 禁用不在有效年份区间内的年份
          return time.getFullYear() > currentYear || time.getFullYear() < startYear || time.getFullYear() > endYear;
        }
      },
    };
  },

  mounted() {
    this.beginTime = this.value[0];
    this.endTime = this.value[1];
  },
  watch: {
    value: function (val) {
      this.beginTime = val[0];
      this.endTime = val[1];
    }
  },
  methods: {
    selectSeason(i) {
      const that = this;
      that.season = i + 1;
      const arr = that.valueArr[i];
      const seasonValue = that.getValue(`${that.year}-${arr}`);
      that.showSeason = false;
      this.showValue = this.$t('components_yearRangePicker.onianoji_du', [this.year,this.season]);
      that.$emit('chooseSeason', seasonValue); // 每次选择时间都将当前选择时间发送到父组件
      this.$emit('input', seasonValue);
    },

    changeTime() {
      if (this.endTime <= this.beginTime) {
        const maxTime = this.beginTime;
        this.beginTime = this.endTime;
        this.endTime = maxTime;
      }
      const Timer = [`${this.beginTime}`, `${this.endTime}`];
      this.$emit('input', Timer);
      this.$emit('change', Timer);
    },


  }
};
</script>

<style lang="scss">
.quarter-picker {
  display: inline;
  .firstBtn {
    height: 30px;
    line-height: 34px;
    width: 100%;
    text-align: center;
  }
  .text {
    text-align: center;
    margin: 15px 0 10px;
  }
  .item {
    text-align: center;
  }
}
.colorDis {
  color: #999 !important;
}
.quarter-picker {
  .el-card__header {
    padding: 12px;
  }
}
</style>
